// extracted by mini-css-extract-plugin
export default {"BuildingCheckersBlock":"BuildingCheckersBlock_BuildingCheckersBlock__V3-P1","housing":"BuildingCheckersBlock_housing__Ik8Zd","title":"BuildingCheckersBlock_title__zDFwh"};